import React, { Component, createRef } from "react";
import { TouchableOpacity, View, Image } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import Player from "./controller";

import { styles } from "./styles";
import { styles as buttonStyles } from "components/icon-button/styles";

const image = require("assets/images/audio.png");

export class AudioPlayer extends Component {
  player = createRef();
  state = { playing: false };

  play = () => {
    this.setState({ playing: true });
    this.player.current?.playRecording();
  };

  onended = () => {
    this.setState({ playing: false });
  };

  pause = () => {
    this.setState({ playing: false });
    this.player.current?.pause();
  };

  removeRecording = () => {
    this.pause();
    this.props.removeFile();
  };

  componentWillUnmount = () => this.pause();

  render = () => {
    const icon = this.state.playing ? "pause" : "play";
    const onPress = this.state.playing ? this.pause : this.play;
    return (
      <>
        <Player
          ref={this.player}
          onended={this.onended}
          savedClip={this.props.savedClip}
        />
        <View style={[buttonStyles.button, styles.container]}>
          <TouchableOpacity onPress={onPress} style={styles.playIcon}>
            <Icon
              name={icon}
              size={buttonStyles._icon?.fontSize}
              color={styles._audioWave.backgroundColor}
            />
          </TouchableOpacity>
          <View style={styles.audioWave}>
            <Image
              source={image}
              style={styles.audioWaveImage}
              height={styles._audioWaveImage?.height}
              width={styles._audioWaveImage?.width}
              resizeMode="center"
            />
          </View>
          <TouchableOpacity
            onPress={this.removeRecording}
            style={styles.removeIcon}
          >
            <Icon
              name="x"
              size={buttonStyles._icon?.fontSize}
              color={styles._audioWave.backgroundColor}
            />
          </TouchableOpacity>
        </View>
      </>
    );
  };
}
